module.exports = __webpack_public_path__ + "img/1834.8f8d449c.gif";